import { render } from "./StudyDataImportDialog.vue?vue&type=template&id=47c1e3dc&scoped=true"
import script from "./StudyDataImportDialog.vue?vue&type=script&lang=js"
export * from "./StudyDataImportDialog.vue?vue&type=script&lang=js"

import "./StudyDataImportDialog.vue?vue&type=style&index=0&id=47c1e3dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c1e3dc"]])

export default __exports__